import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyerNotifications } from '../data/content';
const MINUTES = [2, 3, 4, 5, 6, 7, 8, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const schedule = (delay: number) => {
      showTimeout = window.setTimeout(() => {
        setVisible(true);
        hideTimeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % buyerNotifications.length);
          schedule(9000 + Math.random() * 6000);
        }, 5200);
      }, delay);
    };
    schedule(6000);
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [dismissed]);
  const buyer = buyerNotifications[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-190" data-mp="117o17ogr0ozw">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      x: -24,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      duration: 0.35
    }} className="fixed bottom-24 left-3 right-3 z-30 sm:right-auto sm:max-w-xs" role="status" aria-live="polite" data-id="element-191" data-mp="1151uts5lgfj9">
          <div className="relative flex items-start gap-3 rounded-2xl border border-lime/25 bg-ink-800/95 p-3 pr-8 shadow-2xl backdrop-blur" data-id="element-192" data-mp="i93fyd1jgdu6">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-lime/15" data-id="element-193" data-mp="x2y827dh5oio">
              <CheckCircle2Icon className="h-5 w-5 text-lime" data-id="element-194" data-mp="28kg4smwn1nvp" />
            </span>
            <div className="min-w-0" data-id="element-195" data-mp="28mkg3pwv9p60">
              <p className="text-xs font-bold leading-snug text-white sm:text-sm" data-id="element-196" data-mp="23lwigle4ua2t">
                {buyer.name} · {buyer.country}
              </p>
              <p className="mt-0.5 text-[11px] leading-snug text-white/65" data-id="element-197" data-mp="2aobgkvh5af07">
                just purchased the Anti-Refinement System™
              </p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-wide text-lime" data-id="element-198" data-mp="2km7l34fkubpc">
                {minutes} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 text-white/40 transition hover:text-white" data-id="element-199" data-mp="2pjhltg8f29sh">
              <XIcon className="h-4 w-4" data-id="element-200" data-mp="21v82qm2l8051" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}